export default "__VITE_ASSET__BgXS9QlM__"